module.exports = __webpack_public_path__ + "../resources/img/storebadge_it.47cbd92c.png";